import { useEffect, useState } from "react";
import styles from "./Cabecalho.module.scss";
import { ReactComponent as MenuIcon } from "../../assets/svg/menu_icon.svg";
import { ReactComponent as CloseIcon } from "../../assets/svg/close_icon.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import logo from "../../assets/img/logo.png";
import logoDark from "../../assets/img/logo-dark.png";
import { useTheme } from "../../contexts/ThemeProvider";
import { IoMoon } from "react-icons/io5";
import { Moon, Sun } from "lucide-react";

export default function Cabecalho() {
  const [menuAparecer, setMenuAparecer] = useState(false);
  const [selecionado, setSelecionado] = useState("");
  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const href = useLocation().pathname;

  useEffect(() => {
    switch (href) {
      case "/":
        setSelecionado("Início");
        break;
      case "/servicos":
        setSelecionado("Serviços");
        break;
      case "/empresa":
        setSelecionado("Empresa");
        break;
      case "/casosdesucesso":
        setSelecionado("Casos de sucesso");
        break;
    }
  }, [href]);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      setScrollPosition(position);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={classNames({
        [styles["cabecalho"]]: true,
        [styles["cabecalhoScrolled"]]: scrollPosition > 50 ? true : false,
      })}
    >
      <a href="/">
        <img
          className={classNames({
            [styles["cabecalho__logo"]]: true,
            [styles["cabecalho__logoScrolled"]]:
              scrollPosition > 50 ? true : false,
          })}
          src={logo ? (theme === "light" ? logo : logoDark) : ""}
          alt="Logo da Alcance"
        />
      </a>

      {/* Botão de troca de tema */}
      <div className={styles["cabecalho__menuicon--div"]}>
        <button
          onClick={toggleTheme}
          className={classNames({
            [styles["cabecalho__tema"]]: true,
            [styles["cabecalho__tema--mob"]]: true,
          })}
        >
          {theme === "light" ? <Moon /> : <Sun></Sun>}
        </button>
        <MenuIcon
          className={styles["cabecalho__menuicon"]}
          onClick={() => {
            setMenuAparecer(true);
          }}
        />
      </div>

      <div
        className={classNames({
          [styles["cabecalho__navegacao--div"]]: true,
          [styles["cabecalho__navegacao--div--aparecer"]]: menuAparecer
            ? true
            : false,
        })}
        onClick={() => {
          setMenuAparecer(false);
        }}
      ></div>

      <nav
        className={classNames({
          [styles["cabecalho__navegacao"]]: true,
          [styles["cabecalho__navegacao--aparecer"]]: menuAparecer
            ? true
            : false,
        })}
      >
        <CloseIcon
          onClick={() => {
            setMenuAparecer(false);
          }}
          className={styles["cabecalho__closeicon"]}
        />

        <ul className={styles["cabecalho__lista"]}>
          <Link to={"/"}>
            <li
              className={classNames({
                [styles["cabecalho__link"]]: true,
                [styles["cabecalho__link--selecionado"]]:
                  selecionado === "Início" ? true : false,
              })}
              onClick={() => {
                setSelecionado("Início");
                setMenuAparecer(false);
              }}
            >
              Início
            </li>
          </Link>
          <Link to={"/servicos"}>
            <li
              className={classNames({
                [styles["cabecalho__link"]]: true,
                [styles["cabecalho__link--selecionado"]]:
                  selecionado === "Serviços" ? true : false,
              })}
              onClick={() => {
                setSelecionado("Serviços");
                setMenuAparecer(false);
              }}
            >
              Serviços
            </li>
          </Link>
          <Link to={"/empresa"}>
            <li
              className={classNames({
                [styles["cabecalho__link"]]: true,
                [styles["cabecalho__link--selecionado"]]:
                  selecionado === "Empresa" ? true : false,
              })}
              onClick={() => {
                setSelecionado("Empresa");
                setMenuAparecer(false);
              }}
            >
              Empresa
            </li>
          </Link>
          <Link to={"/casosdesucesso"}>
            <li
              className={classNames({
                [styles["cabecalho__link"]]: true,
                [styles["cabecalho__link--selecionado"]]:
                  selecionado === "Casos de sucesso" ? true : false,
              })}
              onClick={() => {
                setSelecionado("Casos de sucesso");
                setMenuAparecer(false);
              }}
            >
              Casos de sucesso
            </li>
          </Link>
        </ul>

        <div
          className={classNames({
            [styles["cabecalho__contato--div"]]: true,
            [styles["cabecalho__contato--div--mob"]]: true,
          })}
        >
          <Link
            to={"/contato"}
            onClick={() => {
              setSelecionado("");
              setMenuAparecer(false);
            }}
          >
            <button className={styles["cabecalho__contato"]}>Contato</button>
          </Link>
        </div>
      </nav>

      <div
        className={classNames({
          [styles["cabecalho__contato--div"]]: true,
          [styles["cabecalho__contato--div--desk"]]: true,
        })}
      >
        {" "}
        <button onClick={toggleTheme} className={styles["cabecalho__tema"]}>
          {theme === "light" ? <Moon /> : <Sun></Sun>}
        </button>
        <button
          onClick={() => {
            navigate("/contato");
            setSelecionado("");
          }}
          className={styles["cabecalho__contato"]}
        >
          Contato
        </button>
      </div>
    </header>
  );
}
